import React from 'react';
import { DimensionsList } from './list';

export default function DimensionsLanding() {
  return (
    <div>
      <DimensionsList />
    </div>
  );
}